import FreeShippingProgress from './FreeShippingProgress';

export default FreeShippingProgress;
